// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".print-preview[data-v-c648e014]{height:400px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
